import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizCard, WizModal } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/evaluation') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('generalManagerEvaluation', record)
        } else {
            record = Session.get('generalManagerEvaluation') || {}
        }
    }
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/stationmasterEvaluation') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('stationmasterEvaluation', record)
        } else {
            record = Session.get('stationmasterEvaluation') || {}
        }
    }
    return record
}

class GeneralManagerEvaluation extends WizContainer {

    componentName = 'GeneralManagerEvaluation'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/managerEvaluation',
            payload: {
                key: 'managerEvaluation@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    _onBtn = () => {
        const { processContentId, moduleType } = this.state.record
        this.jumpPage('push', `/integrationCounseling/manager/antecedentIntervention/${moduleType === 0 ? 'evaluation' : 'stationmasterEvaluation'}/examine`, { processContentId, moduleType })
    }

    _onConfirm = () => {
        const { processContentId } = this.state.record
        WizModal.confirm({
            title: '注意',
            content: '是否确认进行达标确认操作？',
            onOk: () => {
                this.doAction({
                    path: 'counselingProcess/confirmManagerEvaluation',
                    payload: {
                        key: 'confirmManagerEvaluation@' + processContentId,
                        apiParams: {
                            tutorContentId: processContentId
                        }
                    }
                })
            },
            onCancel() {
            }
        })
    }
    
    propsAndStateOnChange = {
        confirm: this._confirmOnChange.bind(this)
    }

    _confirmOnChange(nextProps, nextState) {
        if (nextProps.confirm.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.confirm.msg)
        }
    }

    render() {
        let { record } = this.state
        let { processContentState, moduleType } = record
        let { list, counselingProcessLoading } = this.props
        let data = list.data && list.data.length ? list.data[0] || {} : {}
        let columns = [{
            title: '执行内容',
            name: 'content',
            dataIndex: 'content',
        }, {
            title: '姓名',
            name: 'fullName',
            dataIndex: 'fullName'
        }, {
            title: '测评日期',
            name: 'evaluationTime',
            dataIndex: 'evaluationTime',
        }, {
            title: '测评结果',
            name: 'evaluationState',
            dataIndex: 'evaluationState',
            render: (v) => {
                switch (v) {
                    case 0:
                        return '未参加'
                    case 1:
                        return '合格'
                    case 2:
                        return '不合格'
                    default:
                        return ''
                }
            }
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 100,
            render: (v, r, i) => {
                let { evaluationTime } = r
                return <WizButton type='link' disabled={processContentState !== 0} onClick={() => this._onBtn()}> {evaluationTime ? '复审' : '评审'} </WizButton>
            }
        }]

        let tableProps = {
            columns,
            dataSource: list.data || [],
            pagination: false,
            bordered: true
        }

        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title={`${moduleType === 0 ? '总经理' : '站长'}测评情况`}>
                    <WizButton
                        type='primary'
                        style={{ marginBottom: 15, width: 90 }}
                        disabled={processContentState !== 0 || data.evaluationState !== 1}
                        onClick={() => this._onConfirm()}>
                        {'达标确认'}
                    </WizButton>
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'managerEvaluation@' + processContentId)
    const confirm = modelUtils.getModelEntity(counselingProcess, 'confirmManagerEvaluation@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        confirm,
        ...loading
    }
}

export default connect(mapStateToProps)(GeneralManagerEvaluation)


